import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { detectEnv } from '@/shared/detect';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { computed, watch, nextTick, ref, useSlots } from 'vue';
var __default__ = {
    name: 'XPopup',
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        title: String,
        safeAreaInsetTop: {
            type: Boolean,
            default: false
        },
        safeAreaInsetBottom: {
            type: Boolean,
            default: false
        },
        closeIconPosition: {
            type: String,
            validator: function(value) {
                return [
                    'top-left',
                    'top-center',
                    'top-right',
                    'bottom-left',
                    'bottom-center',
                    'bottom-right'
                ].includes(value);
            },
            default: 'top-left'
        },
        closeWhenAppBack: {
            type: Boolean,
            default: true
        }
    },
    emits: [
        "input"
    ],
    setup: function(__props, param) {
        var emit = param.emit;
        var props = __props;
        var slots = useSlots();
        var hasNavBar = computed(function() {
            return slots.title || props.title != null && props.title !== '' || slots.action;
        });
        var header = ref(null);
        var footer = ref(null);
        var contentHeight = ref('auto');
        watch(function() {
            return props.value;
        }, function(visible) {
            if (visible) {
                nextTick(function() {
                    var otherHeight = 0;
                    if (header.value) {
                        otherHeight += header.value.clientHeight;
                    }
                    if (footer.value) {
                        otherHeight += footer.value.clientHeight;
                    }
                    if (otherHeight > 0) {
                        contentHeight.value = "calc(100% - ".concat(otherHeight, "px)");
                    }
                });
            }
        });
        var onInput = function(visible) {
            emit('input', visible);
        };
        if (detectEnv.webview) {
            var unwatch;
            watch(function() {
                return props.value;
            }, function(visible) {
                if (!props.closeWhenAppBack) return;
                if (visible) {
                    yxhJsBridge.webOccupationBack('1');
                    window.localBackPressed = function() {
                        console.log('Android returns call to close pop-up window');
                        emit('input', false);
                    };
                } else {
                    yxhJsBridge === null || yxhJsBridge === void 0 ? void 0 : yxhJsBridge.webOccupationBack('0');
                    // 弹窗关闭后，重新设置返回按钮处理
                    if (window.setupBackPressedAfterPopupClose) {
                        window.setupBackPressedAfterPopupClose();
                    } else {
                        window.localBackPressed = function() {};
                    }
                }
            });
        }
        return {
            __sfc: true,
            props: props,
            emit: emit,
            slots: slots,
            hasNavBar: hasNavBar,
            header: header,
            footer: footer,
            contentHeight: contentHeight,
            onInput: onInput
        };
    }
}));
